import {initializeApp} from 'firebase/app';
import {Analytics, initializeAnalytics} from 'firebase/analytics';
import {ENV_TYPES} from '../../environment/EnvironmentTypes';
import {getEnviromentType} from '../../environment/Environment';

import {firebaseConfigQUA, firebaseConfigPRD} from './FirebaseUtils';

const firebaseConfig =
  getEnviromentType() === ENV_TYPES.PROD
    ? firebaseConfigPRD
    : firebaseConfigQUA;

export const app = initializeApp(firebaseConfig);
export const analytics = async (): Promise<Analytics> =>
  initializeAnalytics(app);
